import { type ComponentProps } from 'react'
import { Toaster } from './sonner'

type Props = ComponentProps<typeof Toaster>

export const ToastProvider = (props: Props) => <Toaster {...props} />

ToastProvider.displayName = 'ToastProvider'
